import { HealthPlanRenewal } from '@/modules/Renewals/renewals.types';
import { baseStoreCreator } from '@/utils/store';

export interface HealthPlansPayload {
  healthPlans: HealthPlanRenewal[];
  errors: Record<string, Record<string, string[]>>;
}

export const DEFAULT_VALUES: HealthPlansPayload = {
  healthPlans: [],
  errors: {},
};

export const useHealthPlansStore = baseStoreCreator<HealthPlansPayload>(DEFAULT_VALUES);

export default useHealthPlansStore;
